module.exports = __webpack_public_path__ + "assets/ComunicacaoEventosAdversos.c4bc1287c8c9cd4588dd1aec288408e7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/ComunicacaoEventosAdversos.png
 ** module id = 477
 ** module chunks = 0
 **/